import { PaymentCardBrandIcon } from './PaymentCardBrandIcon';
import { useI18n } from '../i18n';
import {
  formatProfilePaymentCardSummaryLine,
  type ProfileSavedPaymentCard,
} from '../utils/profilePaymentCard';
import styles from './ProfileMenu.module.css';

type ProfileHubPaymentMethodsContentProps = {
  cards: ProfileSavedPaymentCard[];
  onEdit: () => void;
  successMessage?: string | null;
};

export function ProfileHubPaymentMethodsContent({
  cards,
  onEdit,
  successMessage,
}: ProfileHubPaymentMethodsContentProps) {
  const { t, language } = useI18n();

  return (
    <div
      className={[
        styles.hubDetailsPanel,
        language === 'he' ? styles.hubDetailsPanelRtl : styles.hubDetailsPanelLtr,
      ]
        .filter(Boolean)
        .join(' ')}
      dir={language === 'he' ? 'rtl' : 'ltr'}
    >
      {successMessage ? (
        <p className={styles.hubPaymentUpdatedNotice} role="status">
          {successMessage}
        </p>
      ) : null}
      <button
        type="button"
        className={styles.hubDetailsEditBtn}
        onClick={onEdit}
        aria-label={t('profile.hub.editPaymentMethods')}
      >
        <ProfileEditIcon />
        <span>{t('list.edit')}</span>
      </button>
      {cards.length === 0 ? (
        <p className={styles.hubRowDetail} role="status">
          {t('profile.paymentMethods.notSet')}
        </p>
      ) : (
        <ul className={styles.hubVehiclesList}>
          {cards.map((card) => (
            <li key={card.id} className={styles.hubVehicleItem}>
              <PaymentCardBrandIcon brand={card.brand} />
              <span className={styles.hubVehicleLine} dir="ltr">
                {formatProfilePaymentCardSummaryLine(card)}
              </span>
              {card.isPrimary ? (
                <span className={styles.hubVehiclePrimaryBadge}>
                  {t('profile.paymentMethods.primary')}
                </span>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function ProfileEditIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M12 20h9" strokeLinecap="round" />
      <path
        d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
